/**
 * 解析url里面的query参数为对象
 * @param url 地址
 * @returns 对象
 */
export const parseQuery = (url: string): any => {
  const index = url.indexOf('?')
  const obj = {}
  // 说明存在参数
  if (index > 0) {
    let all_query = url.split('?')[1]
    let query_arr = all_query.split('&')
    query_arr.forEach(item => {
      const item_arr = item.split("=")
      obj[item_arr[0]] = item_arr[1]
    })
  }
  return obj;
}